<template>
  <v-card-actions class="card-actions">
    <slot />
  </v-card-actions>
</template>

<script>
export default {};
</script>
